<template>
  <div class="load-more-results">
    <slot v-if="!loaded" />
    <slot v-if="emptyList" name="no-results" />
    <ul v-if="loaded && !emptyList" class="results-grid">
      <li
        v-for="(result, index) in loadList"
        :key="`key_${index}_${Date.now()}_${(Math.random() * 1000000).toFixed(0)}`"
        class="results-grid__item"
      >
        <div
          v-tag:productclick.dom="{ label: 'Product Click' }"
          v-tag:productimpression.dom="{ label: 'Product Impressions' }"
          data-tag-wrapper
        >
          <div
            :data-tag-product-name="result.productTagging.name"
            :data-tag-product-subname="result.productTagging.subname"
            :data-tag-product-category="result.productTagging.category"
            :data-tag-product-variant="result.productTagging.variant"
            :data-tag-product-price="result.productTagging.price"
            :data-tag-product-brand="result.productTagging.brand"
            :data-tag-product-currency="result.productTagging.currency"
            :data-tag-product-dimension35="result.productTagging.dimension35"
            :data-tag-product-dimension38="result.productTagging.dimension38"
            :data-tag-product-dimension39="result.productTagging.dimension39"
            :data-tag-product-dimension49="result.productTagging.dimension49"
            :data-tag-product-dimension59="result.productTagging.dimension59"
            :data-tag-product-dimension153="result.productTagging.dimension153"
            :data-tag-product-dimension154="result.productTagging.dimension154"
            :data-tag-product-id="result.productTagging.id"
            data-tag-product-identifier
            :data-tag-product-list="result.productTagging.list"
            :data-tag-product-metric5="result.productTagging.metric5"
            :data-tag-product-position="index + 1"
          >
            <product-result>
              <template slot="face">
                <a
                  class="results__card-front front"
                  :class="{ 'results__card-front--square': squareImages }"
                  :href="result.productHref"
                >
                  <div v-if="result.frontside.icons" class="front__icon">
                    <img
                      v-for="(badge, i) in result.frontside.icons"
                      v-show="badge.url"
                      :key="i"
                      v-srcset="badge.url"
                      :alt="badge.alt"
                      src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                    />
                  </div>
                  <div class="image">
                    <img
                      v-srcset="result.frontside.image.srcset"
                      :alt="result.frontside.image.alt"
                      class="image__item"
                      src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                    />
                  </div>
                  <div class="front__text">
                    <div v-if="result.frontside.title" class="front__title product-heading">
                      <h3>{{ result.frontside.title }}</h3>
                    </div>
                    <p class="front__benefit">{{ result.frontside.mainBenefit }}</p>
                    <LazyloadingWrapper
                      v-if="hasBazaarVoiceInlineRatings && result.productCode"
                      class="rating"
                    >
                      <div
                        :data-bv-product-id="result.productCode"
                        data-bv-seo="false"
                        data-bv-show="inline_rating"
                      />
                    </LazyloadingWrapper>
                  </div>
                </a>
              </template>

              <template slot="back">
                <div
                  class="results__card-back back"
                  :class="{ 'results__card-back--square': squareImages }"
                >
                  <a
                    v-tag:useractionevent="{
                      action: result.backside.buyCta.tagging.eventAction,
                      category: result.backside.buyCta.tagging.eventCategory,
                      ecommerce: undefined,
                      event: 'uaevent',
                      label: `${result.productCode}::${result.frontside.title}`,
                    }"
                    class="back__info"
                    :href="result.backside.pdpCta.link"
                    :target="result.backside.pdpCta.target"
                  >
                    <div class="richtext back__title product-heading is-sr-only">
                      {{ result.backside.title }}
                    </div>
                    <div class="image">
                      <img
                        v-srcset="result.backside.image.srcset"
                        :alt="result.backside.image.alt"
                        class="image__item"
                        src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      />
                    </div>
                  </a>
                  <button
                    v-if="
                      channelAdvisor &&
                        result.backside.buyCta.channelAdvisorUrl &&
                        !result.backside.buyCta.isComingSoon
                    "
                    v-tag:useractionevent="{
                      action: result.backside.buyCta.tagging.eventAction,
                      category: result.backside.buyCta.tagging.eventCategory,
                      ecommerce: 'undefined',
                      event: 'uaevent',
                      label: `${result.backside.buyCta.upc}::${result.frontside.title}`,
                    }"
                    v-trigger-channel-advisor="result.backside.buyCta.channelAdvisorUrl"
                    class="btn back__cta back__btn btn--primary"
                  >
                    {{ result.backside.buyCta.label }}
                  </button>
                  <mik-mak
                    v-if="wtbId && !result.backside.buyCta.isComingSoon"
                    :wtb-id="wtbId"
                    :label="result.backside.buyCta.label"
                    :sticky="false"
                    :data-mm-id-type="mikMakProductIdType"
                    :product="
                      result.productTagging
                        ? {
                            ...result.productTagging,
                            id: result.backside.buyCta.upc,
                            name: result.frontside.title,
                          }
                        : {
                            name: result.frontside.title,
                            id: result.backside.buyCta.upc,
                          }
                    "
                    css-class="btn back__cta back__btn btn--primary"
                  />
                  <a
                    v-if="
                      !channelAdvisor &&
                        !wtbId &&
                        result.backside.buyCta.link &&
                        !result.backside.buyCta.isComingSoon
                    "
                    v-tag:useractionevent="{
                      action: result.backside.buyCta.tagging.eventAction,
                      category: result.backside.buyCta.tagging.eventCategory,
                      ecommerce: undefined,
                      event: 'uaevent',
                      label: `${result.productCode}::${result.frontside.title}`,
                    }"
                    class="btn back__cta btn--primary"
                    :href="result.backside.buyCta.link"
                    :target="result.backside.buyCta.target"
                  >
                    {{ result.backside.buyCta.label }}
                  </a>

                  <a
                    v-if="result.backside && result.backside.pdpCta && result.backside.pdpCta.link"
                    v-tag:useractionevent="{
                      action: result.backside.buyCta.tagging.eventAction,
                      category: result.backside.buyCta.tagging.eventCategory,
                      ecommerce: undefined,
                      event: 'uaevent',
                      label: `${result.productCode}::${result.frontside.title}`,
                    }"
                    class="btn back__cta btn--ghost"
                    :href="result.backside.pdpCta.link"
                    :target="result.backside.pdpCta.target"
                  >
                    {{ result.backside.pdpCta.label }}
                  </a>
                </div>
              </template>
            </product-result>
          </div>
        </div>
      </li>
    </ul>
    <div
      :aria-live="hasMoreResultsToLoad ? 'polite' : 'off'"
      :class="['load-more-results__loading', { 'load-more-results__loading--show': loading }]"
    >
      <div v-if="loading">
        <span class="is-sr-only">{{ loadingStateLabel }}</span>
        <slot name="loading" />
      </div>
    </div>
    <div v-if="hasMoreResultsToLoad && !emptyList" class="load-more-results__cta">
      <button class="load-more-results__cta-btn" @click="loadMoreResults">
        {{ ctaLabel }}
      </button>
    </div>
  </div>
</template>

<script>
  import ProductResult from '@Feature/ProductResult/code/Scripts/components/ProductResult/ProductResult.vue';
  import MikMak from '@Feature/MikMak/code/Scripts/components/MikMak/MikMak.vue';
  import { srcset } from '@Foundation/directives/srcset/srcset';
  import { tag } from '@Foundation/analyticsHandler/directives/tag';
  import { triggerChannelAdvisor } from '@Foundation/directives/triggerChannelAdvisor/triggerChannelAdvisor';
  import LazyloadingWrapper from '@Feature/RatingsAndReviews/code/Scripts/components/LazyloadingWrapper/LazyloadingWrapper.vue';
  import { mapGetters } from 'vuex';

  export default {
    name: 'LoadMoreResults',
    directives: {
      srcset,
      tag,
      triggerChannelAdvisor,
    },
    components: {
      ProductResult,
      LazyloadingWrapper,
      MikMak,
    },
    props: {
      totalItemsNumber: {
        type: Number,
        required: true,
      },
      initialItemsNumber: {
        type: Number,
        required: true,
      },
      moreItemsNumber: {
        type: Number,
        required: true,
      },
      apiUrl: {
        type: String,
        required: true,
      },
      loadMoreCtaLabelPart1: {
        type: String,
        required: false,
        default: 'View',
      },
      loadMoreCtaLabelPart2: {
        type: String,
        required: false,
        default: 'more >',
      },
      loadingStateLabel: {
        type: String,
        required: false,
        default: 'Loading more results',
      },
      hasMore: {
        type: Boolean,
        required: false,
        default: false,
      },
      initialResults: {
        type: Array,
        required: true,
        default: undefined,
      },
      hasBazaarVoiceInlineRatings: {
        type: Boolean,
        required: false,
        default: false,
      },
      loadParameters: {
        type: Object,
        required: true,
      },
      disableStore: {
        type: Boolean,
        required: false,
        default: false,
      },
      channelAdvisor: {
        type: Boolean,
        required: false,
        default: false,
      },
      squareImages: {
        type: Boolean,
        required: false,
        default: false,
      },
      wtbId: {
        type: String,
        required: false,
        default: null,
      },
      mikMakProductIdType: {
        type: String,
        required: false,
        default: null,
      },
    },
    data() {
      return {
        url: null,
        filterUrl: null,
        parameters: null,
        loadList: [],
        hasMoreResultsToLoad: false,
        loading: false,
        loaded: false,
        itemsLeft: null,
      };
    },
    computed: {
      ...mapGetters('searchFiltersStore', [
        'selectedProductsFiltersIds',
        'selectedProductsSorting',
      ]),
      ctaLabel() {
        return this.itemsLeft <= this.moreItemsNumber
          ? `${this.loadMoreCtaLabelPart1} ${this.itemsLeft} ${this.loadMoreCtaLabelPart2}`
          : `${this.loadMoreCtaLabelPart1} ${this.moreItemsNumber} ${this.loadMoreCtaLabelPart2}`;
      },
      emptyList() {
        return this.loadList.length === 0;
      },
    },
    mounted() {
      this.loadList = this.initialResults || [];
      this.url = this.apiUrl;
      this.parameters = this.loadParameters;
      this.hasMoreResultsToLoad = this.hasMore;
      this.loaded = true;
      this.itemsLeft = this.totalItemsNumber - this.initialItemsNumber;
    },
    methods: {
      loadMoreResults() {
        this.loading = true;
        const parseJSON = response => response.json();

        if (!this.disableStore) {
          this.parameters.selectedFilters = this.selectedProductsFiltersIds;
          this.parameters.selectedSorting = this.selectedProductsSorting;
        }

        fetch(this.url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json;charset=utf-8' },
          credentials: 'same-origin',
          body: JSON.stringify(this.parameters),
        })
          .then(parseJSON)
          .then(data => {
            this.handleResponse(data);
          })
          .catch(error => {
            this.loading = false;
            console.error('Could not load results', error); // eslint-disable-line no-console
          });
      },
      resetComponent(loadList, parameters, itemsLeft, hasMoreResultsToLoad) {
        this.loadList = loadList;
        this.parameters = parameters;
        this.itemsLeft = itemsLeft;
        this.hasMoreResultsToLoad = hasMoreResultsToLoad;
      },
      handleResponse(data) {
        if (data.loadParameters) {
          this.parameters = data.loadParameters;
        }
        if (data.results) {
          this.loadList = [].concat(this.loadList, data.results);
          this.itemsLeft -= this.moreItemsNumber;
          this.hasMoreResultsToLoad = this.itemsLeft <= 0 ? false : data.hasMore;
        }
        this.loading = false;
      },
    },
  };
</script>
